import { Drawer } from "@material-ui/core";
import * as PropTypes from "prop-types";
import styled from "styled-components";
import closeIcon from "../../assets/closeIcon.svg";

const ContentWrapper = styled.div`
  padding: 24px;
`;

const HeaderWrapper = styled.div`
  display: flex;
  padding-bottom: 16px;
`;

const Header = styled.div`
  font-family: Roboto;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 32px;
  letter-spacing: 1.5px;
  text-align: left;
  color: #000000DE;
`;

const CloseIcon = styled.img`
  height: 24px;
  margin-left: auto;
  padding-right: calc(41px - 24px);
`;

const SectionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 64px;
`;

const SectionContent = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 16px;
`;
const SectionHeader = styled.div`
  font-family: Roboto;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0em;
  text-align: left;
  text-transform: uppercase;
  color: #009245;
`;

const TextHeader = styled.div`
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
  letter-spacing: 0em;
  text-align: left;
  text-transform: uppercase;
  color: #111111;
  padding-bottom: 4px;
`;
const Text = styled.div`
  font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0em;
  text-align: left;
  color: background: #4B4B4B;
`;

const RFPInfoDrawer = ({showInfoDrawer, onClose}) => {
  return (
    <Drawer
      open={showInfoDrawer}
      onClose={onClose}
      anchor="bottom"
    >
      <ContentWrapper>
        <HeaderWrapper>
          <Header>Deposit Info</Header>
          <CloseIcon src={closeIcon} onClick={onClose} />
        </HeaderWrapper>
        <SectionWrapper>
          <SectionContent>
            <SectionHeader>How to complete your deposit</SectionHeader>
            <div>
              <TextHeader>Step 1</TextHeader>
              <Text>Wait for the mobile notification from your bank, then tap it.</Text>
            </div>
            <div>
              <TextHeader>Step 2</TextHeader>
              <Text>Log in to your bank's app, check the details and approve the Request for Payment.</Text>
            </div>
            <div>
              <TextHeader>Step 3</TextHeader>
              <Text>Return to the merchant's app or website and your funds will be available to use.</Text>
            </div>
          </SectionContent>
          <SectionContent>
            <SectionHeader>Common Questions</SectionHeader>
            <TextHeader>I don't see my bank's notification, how should I proceed?</TextHeader>
            <Text>Make sure you check the mobile phone where you have installed your bank's app.</Text>
            <Text>If you still don't see the notification after 1 minute, login to your bank's app to accept the Request for Payment.</Text>
          </SectionContent>
        </SectionWrapper>
      </ContentWrapper>
    </Drawer>
  );
};

RFPInfoDrawer.propTypes = {
  showInfoDrawer: PropTypes.bool,
  onClose: PropTypes.func,
};
RFPInfoDrawer.defaultProps = {
  showInfoDrawer: false,
  onClose: null,
};

export default RFPInfoDrawer;